import React from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useNavigate } from "react-router-dom";

export default function About() {
  const navigate = useNavigate();

  // --- Animation Variants ---
  const slideInLeft = {
    hidden: { opacity: 0, x: -120 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { duration: 0.8, ease: "easeOut" },
    },
  };

  const slideInRight = {
    hidden: { opacity: 0, x: 120 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { duration: 0.8, ease: "easeOut" },
    },
  };

  const sectionScrollVariant = {
    hidden: { opacity: 0, y: 100, scale: 0.98 },
    visible: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: { duration: 1, ease: "easeOut" },
    },
  };

  const listItemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: { delay: i * 0.1, duration: 0.5 },
    }),
  };

  const financialItems = [
    "Private Market Research",
    "Capital Market Research",
    "Commodities Intelligence",
    "Sustainable Investment Research",
  ];

  const influencerItems = [
    "Influencer Campaign Strategy",
    "Content & Creative Direction",
    "Full Campaign Execution",
    "LinkedIn, Twitter & Instagram Campaigns",
    "Performance Analytics & Reporting",
    "Twitter Trending & Seeding Campaigns",
    "Website Development & Google Ads",
  ];

  // --- Scroll-based Parallax ---
  const { scrollYProgress } = useScroll();
  const yParallax = useTransform(scrollYProgress, [0, 1], [0, -150]);

  return (
    <section
      id="about"
      className="about-section py-5"
      // style={{
      //   background:
      //     "linear-gradient(135deg, #ffffff 0%, #f5f7fa 40%, #e6ecf5 100%)",
      // }}
    >
      <motion.div className="container" style={{ y: yParallax }}>
        {/* ---------- Section Heading ---------- */}
        <motion.h2
          className="section-title text-center fw-bold mb-4"
          initial={{ opacity: 0, y: -40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.8 }}
        >
          About{" "}
          <span
            style={{
              background: "linear-gradient(90deg,#ff006e,#ff8c00)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            Digital Ledger Media
          </span>
        </motion.h2>

        <motion.p
  className="lead text-black text-center mx-auto mb-5 "
  style={{ 
    maxWidth: "750px", 
    lineHeight: "1.8", 
    color: "#005effff !important" 
  }}
  initial={{ opacity: 0, y: 40 }}
  whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true, amount: 0.4 }}
  transition={{ duration: 1, delay: 0.2 }}
>
  Digital Ledger Media is a modern growth agency founded by two friends.
  We combine the art of storytelling with the science of financial
  strategy. The goal is simple: build hype that performs and make
  decisions that pay off.
  <br /> <br />
  No fluff. No guesswork. Just strong strategy, powerful execution, and
  results that speak louder than words.
</motion.p>


        {/* ---------- Influencer Division (with scroll motion) ---------- */}
        <motion.div
          className="row align-items-center mt-5 g-4"
          variants={sectionScrollVariant}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.3 }}
        >
          <motion.div
            className="col-md-6"
            initial="hidden"
            whileInView="visible"
            variants={slideInLeft}
            viewport={{ once: true, amount: 0.3 }}
          >
            <motion.h3
              className="fw-semibold mb-3"
              initial={{ opacity: 0, y: -20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1 }}
              style={{ color: "#212529" }}
            >
              Influencer Marketing Division
            </motion.h3>

            {/* <motion.p
              className="text-secondary mb-4 fs-5 fst-italic"
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.2 }}
            >
              Where brands meet authentic voices.
            </motion.p> */}

            <motion.h4
              className="fw-bold mb-3"
              initial={{ opacity: 0, y: -20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1 }}
              style={{ color: "#ff006e" }}
            >
              Where brands meet authentic voices.
            </motion.h4>

            <motion.h4
              className="fw-bold mb-3"
              initial={{ opacity: 0, y: -20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1 }}
              style={{ color: "#ff006e" }}
            >
              Services :
            </motion.h4>

            <ul className="list-unstyled">
              {influencerItems.map((item, index) => (
                <motion.li
                  key={index}
                  custom={index}
                  variants={listItemVariants}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.3 }}
                  whileHover={{
                    scale: 1.05,
                    color: "#ff006e",
                    transition: { duration: 0.2 },
                  }}
                  className="mb-2 d-flex align-items-center gap-2"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    navigate(`/finacialservice/${item.replace(/ /g, "-")}`)
                  }
                >
                  <i
                    className="bi bi-graph-up-arrow"
                    style={{ color: "#ff8c00" }}
                  ></i>
                  {item}
                </motion.li>
              ))}
            </ul>
          </motion.div>

          {/* --- Influencer Videos --- */}
          <motion.div
            className="col-md-6 text-center d-flex justify-content-center gap-3 flex-wrap"
            initial="hidden"
            whileInView="visible"
            variants={slideInRight}
            viewport={{ once: true, amount: 0.3 }}
          >
            {[
          "/videos/Influencer1.mp4",
          "/videos/Influencer2.mp4",
          "/videos/Influencer3.mp4",
        ].map((videoSrc, i) => (
              <motion.video
                key={i}
                src={videoSrc}
                autoPlay
                loop
                muted
                playsInline
                className="img-fluid rounded-4 shadow-lg"
                initial={{ opacity: 0, scale: 0.9, y: 40 }}
                whileInView={{ opacity: 1, scale: 1, y: 0 }}
                whileHover={{ scale: 1.05 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.8, delay: i * 0.2 }}
                style={{
                  width: "200px",
                  height: "350px",
                  objectFit: "cover",
                  borderRadius: "20px",
                  boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
                }}
              />
            ))}
          </motion.div>
        </motion.div>

        {/* ---------- Financial Division (with scroll motion) ---------- */}
        <motion.div
          className="row align-items-center mt-5 g-4 flex-md-row-reverse"
          variants={sectionScrollVariant}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.3 }}
        >
          <motion.div
            className="col-md-6"
            initial="hidden"
            whileInView="visible"
            variants={slideInRight}
            viewport={{ once: true, amount: 0.3 }}
          >
            <motion.h3
              className="fw-semibold mb-3"
              initial={{ opacity: 0, y: -20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1 }}
              style={{ color: "#212529" }}
            >
              Financial Intelligence Division
            </motion.h3>

            <motion.h4
              className="fw-bold mb-3"
              initial={{ opacity: 0, y: -20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1 }}
              style={{ color: "#ff8c00" }}
            >
              We deliver decision-grade Financial Intelligence
            </motion.h4>
            <motion.h4
              className="fw-bold mb-3"
              initial={{ opacity: 0, y: -20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1 }}
              style={{ color: "#ff8c00" }}
            >
               Services :
            </motion.h4>

            <ul className="list-unstyled">
              {financialItems.map((item, index) => (
                <motion.li
                  key={index}
                  custom={index}
                  variants={listItemVariants}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.3 }}
                  whileHover={{
                    scale: 1.05,
                    color: "#ff8c00" ,
                    transition: { duration: 0.2 },
                  }}
                  className="mb-2 d-flex align-items-center gap-2"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    navigate(`/service/${item.replace(/ /g, "-")}`)
                  }
                >
                  <i
                    className="bi bi-graph-up-arrow"
                    style={{ color: "#ff8c00" }}
                  ></i>
                  {item}
                </motion.li>
              ))}
            </ul>
          </motion.div>

          {/* --- Financial Videos --- */}
          <motion.div
  className="col-md-6 d-flex justify-content-center gap-3 flex-wrap"
  initial="hidden"
  whileInView="visible"
  variants={slideInLeft}
  viewport={{ once: true, amount: 0.3 }}
>
  {[
    "/videos/Financial1.mp4",
    "/videos/Financial2.mp4",
    "/videos/Financial3.mp4",
  ].map((videoSrc, i) => (
    <motion.div
      key={i}
      initial={{ opacity: 0, y: 40, scale: 0.95 }}
      whileInView={{ opacity: 1, y: 0, scale: 1 }}
      viewport={{ once: true, amount: 0.3 }}
      whileHover={{
        scale: 1.05,
        y: -8,
        boxShadow: "0 8px 25px rgba(0,0,0,0.25)",
      }}
      transition={{ duration: 0.6, delay: i * 0.2 }}
      className="rounded-4 overflow-hidden shadow-lg"
      style={{
        width: "200px",
        height: "350px",
        background: "linear-gradient(180deg, #f5f7fa 0%, #e6ecf5 100%)",
        borderRadius: "20px",
        position: "relative",
      }}
    >
      <motion.video
        src={videoSrc}
        autoPlay
        loop
        muted
        playsInline
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          borderRadius: "20px",
        }}
      />
    </motion.div>
  ))}
</motion.div>

        </motion.div>
      </motion.div>
    </section>
  );
}
